import { render, staticRenderFns } from "./my-coupon-receive-list.vue?vue&type=template&id=ba70f14a&scoped=true&"
import script from "./my-coupon-receive-list.vue?vue&type=script&lang=js&"
export * from "./my-coupon-receive-list.vue?vue&type=script&lang=js&"
import style0 from "./my-coupon-receive-list.vue?vue&type=style&index=0&id=ba70f14a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba70f14a",
  null
  
)

export default component.exports